import * as React from 'react'

import { Switch } from '~/client/src/shared/components/shadcn-ui/switch'

interface ToggleControlsProps {
  isEnabled: boolean
  onToggle: () => void
  shouldRenderCheckbox?: boolean
  isChecked?: boolean
  onCheckboxToggle?: () => void
  isDisabledToggle?: boolean
}

const COLUMN_CLASS = 'tw:flex tw:w-28 tw:shrink-0 tw:items-center'

const ToggleControls: React.FC<ToggleControlsProps> = ({
  isEnabled,
  onToggle,
  shouldRenderCheckbox,
  isChecked,
  onCheckboxToggle,
  isDisabledToggle,
}) => (
  <>
    <div className={COLUMN_CLASS}>
      <Switch
        checked={isEnabled}
        onCheckedChange={onToggle}
        disabled={isDisabledToggle}
      />
    </div>
    <div className={COLUMN_CLASS}>
      {shouldRenderCheckbox && (
        <Switch
          checked={isChecked}
          // The landing page can only move to another app, never be unset.
          onCheckedChange={checked => checked && onCheckboxToggle?.()}
          disabled={!isEnabled}
        />
      )}
    </div>
  </>
)

export default ToggleControls
